export default __webpack_public_path__ + "static/14-db331213f166db4f42d58674ac8fdcd2.jpg";